import React from "react";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import ButtonComponent from "../../commonComponent/ButtonComponent";
import EditorModeSwitch from "../EditorModeSwitch";
import TitleInputComponent from "../../organisms/TitleInputComponent";
import { EDITOR_MODES } from "../../../constants/editorMode.constants";

const ACTIONS_CLASS = "flex shrink-0 items-center gap-[10px]";
const BAR_CLASS = "flex w-full flex-col gap-3 xl:flex-row xl:items-center";
const CONTROLS_CLASS =
  "flex w-full flex-wrap items-center justify-between gap-3 xl:w-auto xl:shrink-0 xl:flex-nowrap";
const MENU_BUTTON_CLASS =
  "flex h-10 w-10 shrink-0 items-center justify-center rounded-md border border-border bg-surface text-primary shadow-sm hover:bg-surface-muted focus:outline-none focus:ring-2 focus:ring-primary";

const RecentMenuButton = ({ isVisible, onClick }) => {
  if (!isVisible) return null;

  return (
    <button
      aria-label="Open recent titles"
      className={MENU_BUTTON_CLASS}
      onClick={onClick}
      title="Recent titles"
      type="button"
    >
      <MenuRoundedIcon fontSize="small" />
    </button>
  );
};

const NoteActionButtons = ({
  onClear,
  onDelete,
  onSave,
  onView,
  saveMode,
}) => (
  <div className={ACTIONS_CLASS}>
    <ButtonComponent
      buttonName={saveMode === "offline" ? "Save 🔏" : "Save"}
      onClick={onSave}
      tone="actionSave"
    />
    <ButtonComponent buttonName="View" onClick={onView} tone="actionView" />
    <ButtonComponent buttonName="Clear" onClick={onClear} tone="actionClear" />
    <ButtonComponent buttonName="Delete" onClick={onDelete} tone="actionDelete" />
  </div>
);

const NoteActionBar = ({
  editorMode,
  isLoading,
  noteTitle,
  onClear,
  onDelete,
  onEditorModeChange,
  onRecentMenuOpen,
  onSave,
  onTitleChange,
  onTitleDropdownChange,
  onTitleKeyDown,
  onView,
  saveMode,
  titleDropdownOptions,
}) => {
  const isCanvasMode = editorMode === EDITOR_MODES.CANVAS;

  return (
    <div className={BAR_CLASS}>
      <TitleInputComponent
        dropdownObject={titleDropdownOptions}
        handleDropDownChange={onTitleDropdownChange}
        handleKeyboardEvents={onTitleKeyDown}
        loading={isLoading}
        onChange={onTitleChange}
        placeholder="Add Note Title"
        saveMode={saveMode}
        value={noteTitle}
      />
      <div className={CONTROLS_CLASS}>
        <EditorModeSwitch
          onModeChange={onEditorModeChange}
          selectedMode={editorMode}
        />
        <NoteActionButtons
          onClear={onClear}
          onDelete={onDelete}
          onSave={onSave}
          onView={onView}
          saveMode={saveMode}
        />
        <RecentMenuButton isVisible={isCanvasMode} onClick={onRecentMenuOpen} />
      </div>
    </div>
  );
};

export default NoteActionBar;
